import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { useState } from 'react'

import {
   ChromeBrowserIcon,
   FirefoxBrowserIcon,
   MicrosoftEdgeBrowserIcon,
   SafariBrowserIcon,
   XCloseIcon
} from '@flowwai-frontend/design-system/icons'
import { isMobile } from '@flowwai-frontend/shared/utils/web'

import useGetCrossBrowserDetails from '../../hooks/useGetBrowserDetails/useGetCrossBrowserDetails'
import {
   USER_AGENT_CHROME_KEY,
   USER_AGENT_EDGE_KEY,
   USER_AGENT_FIREFOX_KEY,
   USER_AGENT_GOOGLE_SEARCH_KEY,
   USER_AGENT_SAFARI_KEY
} from '../../constants/BrowserConstants'

import themes from '../../themes'

import * as Styles from './styles'

const CrossBrowserBanner = () => {
   const [isBannerVisible, setIsBannerVisible] = useState(true)

   const colorTheme = themes.light.crossBrowserBanner

   const { getCrossBrowserCompatibility } = useGetCrossBrowserDetails()

   const browserDetails = getCrossBrowserCompatibility()

   const { browserName, isVersionSupported } = browserDetails

   const renderIcon = (): React.ReactNode => {
      const height = isMobile() ? 24 : 28
      const width = isMobile() ? 24 : 28
      switch (browserName) {
         case USER_AGENT_SAFARI_KEY:
            return <SafariBrowserIcon height={height} width={width} />
         case USER_AGENT_CHROME_KEY:
         case USER_AGENT_GOOGLE_SEARCH_KEY:
            return <ChromeBrowserIcon height={height} width={width} />
         case USER_AGENT_FIREFOX_KEY:
            return <FirefoxBrowserIcon height={height} width={width} />
         case USER_AGENT_EDGE_KEY:
            return <MicrosoftEdgeBrowserIcon height={height} width={width} />
         default:
            return <></>
      }
   }

   const renderCloseIconButton = (): React.ReactElement => (
      <button onClick={() => setIsBannerVisible(false)}>
         <XCloseIcon height={16} width={16} />
      </button>
   )

   const renderChromeText = (): React.ReactNode => (
      <div className={cn(Styles.bannerTextStyles)}>
         <p
            className={cn(
               Styles.getBannerTextStyles(isMobile()),
               colorTheme.textStyles
            )}
         >
            Chrome for a better experience
         </p>
      </div>
   )

   //TODO:_ The text should move to i18 file
   const renderBannerText = (): React.ReactElement => {
      const isChromeBrowser = browserName === USER_AGENT_CHROME_KEY
      return (
         <div className={cn(Styles.bannerTextContainerStyles(isMobile()))}>
            <div className={cn(Styles.bannerTextStyles)}>
               <div className={cn(Styles.iconContainerStyles)}>
                  {renderIcon()}
               </div>
               <p
                  className={cn(
                     Styles.getBannerTextStyles(isMobile()),
                     colorTheme.textStyles
                  )}
               >
                  Use the latest version of your browser
                  {!isChromeBrowser ? <span className='ml-1'>or</span> : null}
               </p>
            </div>
            {!isChromeBrowser ? renderChromeText() : null}
         </div>
      )
   }
   const shouldShowBanner = isBannerVisible && !isVersionSupported

   return shouldShowBanner ? (
      <div
         className={cn(
            Styles.getBannerContainerStyles(isMobile()),
            colorTheme.bannerBgColor
         )}
      >
         {renderBannerText()}
         {renderCloseIconButton()}
      </div>
   ) : null
}

export default observer(CrossBrowserBanner)
